<input
  type="file"
  class="file-input"
  (change)="onInputFileSelected($event)"
  #fileUpload
  [accept]="acceptedFiles"
  [attr.multiple]="allowMultipleFiles ? allowMultipleFiles : null"
/>
<div>
  <div class="d-flex flex-col">
    <div
      class="col fileUpload"
      [class.disabled]="uploadInProgress"
      [fileDragAndDrop]="!uploadInProgress"
      (filesChange)="onFilesChanged($event)"
      [allowMultipleFiles]="allowMultipleFiles"
    >
      <p>Drag and drop files here or</p>
      <button
        [disabled]="uploadInProgress"
        class="btn btn-outline-primary btn-sm"
        (click)="fileUpload.click()"
      >
        Browse Files
      </button>
    </div>

    <!-- progress bar -->

    <div class="files-container mt-3" *ngIf="files.length">
      <ng-container
        *ngFor="let file of files; let first = first; let last = last"
      >
        <div
          class="progressContainer d-flex"
          [class.first-file]="first"
          [class.last-file]="last"
          [class.clickable]="file.error"
          (click)="file.errorExpanded = !file.errorExpanded"
        >
          <div class="progressInnerContainer">
            <div class="progressText">
              <div class="error-icon">
                <fa-icon
                  *ngIf="file.error"
                  [icon]="file.errorExpanded ? icons.up : icons.down"
                ></fa-icon>
              </div>
              <div class="iconDiv">
                <img
                  src="assets/document-text.svg"
                  class="documentSVG"
                  alt="document svg"
                />
              </div>
              <div class="d-flex flex-col col-3 mt-0">
                <p class="fileName">{{ file?.file.name }}</p>
              </div>
              <div class="information col-5 mt-0">
                <div class="content">
                  <span *ngIf="file.error"
                    >Error importing file. Click to see the details.</span
                  >
                  <div
                    [ngClass]="{
                      pending:
                        !file.progress &&
                        !file.error &&
                        !file.processed &&
                        !file.processing,
                      error: file.error,
                      imported:
                        file.progress === file.file.size && file.processed,
                      importing:
                        (file.progress && file.progress < file.file.size) ||
                        file.processing
                    }"
                    *ngIf="!file.error"
                  >
                    <span class="progress__text">
                      {{
                        !file.progress &&
                        !file.error &&
                        !file.processed &&
                        !file.processing
                          ? data?.isEdit
                            ? "Update pending"
                            : "Import pending"
                          : !file.processing &&
                            file.progress &&
                            file.progress < file.file.size
                          ? "Reading..."
                          : file.processing
                          ? "Processing..."
                          : file.processed
                          ? data?.isEdit
                            ? "Updated"
                            : "Imported"
                          : data?.isEdit
                          ? "Waiting to be updated..."
                          : "Waiting to be imported..."
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="progress col">
                <div
                  class="progress-bar"
                  [class.error]="file.error"
                  [style.width.%]="(file.progress / file.file.size) * 100"
                ></div>
              </div>
            </div>
          </div>
          <div class="uploadSuccess">
            <div class="fileInfo">
              <div class="closeButtonContainer xButton">
                <fa-icon
                  *ngIf="!uploadInProgress"
                  [icon]="removeIcon"
                  (click)="removeFile(file, fileUpload)"
                  title="Remove file"
                >
                </fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div
          class="error-panel"
          [class.expanded]="file.error && file.errorExpanded"
        >
          <ng-container *ngIf="isObject(file.error?.errors); else simpleResult">
            <table>
              <tbody>
                <tr *ngFor="let item of file.error?.errors | keyvalue">
                  <td>{{ item.key }}</td>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>
          <ng-template #simpleResult>
            <pre>{{ formatErrorMessage(file.error) }}</pre>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</div>
